import api from './api';

const listLanguages = query => api.get('/api/languages/', { params: query });

export default { listLanguages };
